<template>
  <v-row no-gutters>
    <!-- hide playlist videos' views count -->
    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col cols="6" class="d-flex flex-column">
          <span class="body-regular-small neutral-20-dark--text">{{
            $t('message.playlist.settings.tabs.advanced.hideViews.title')
          }}</span>
        </v-col>
        <v-col cols="6" class="d-flex justify-end">
          <v-switch
            v-model="playlistData.hide_views"
            :hide-details="true"
            class="mt-0 pt-0"
          >
          </v-switch>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col class="d-flex flex-column" style="max-width: 192px">
          <span class="body-regular-small title-text-color">{{
            $t('message.playlist.settings.tabs.advanced.creatorName.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t('message.playlist.settings.tabs.advanced.creatorName.desc')
          }}</span>
        </v-col>
        <v-col class="d-flex justify-end pl-10">
          <v-input hide-details v-model="playlistData.creator_name"></v-input>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col class="d-flex flex-column" style="max-width: 200px">
          <span class="body-regular-small title-text-color">{{
            $t('message.playlist.settings.tabs.advanced.externalButton.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t('message.playlist.settings.tabs.advanced.externalButton.desc')
          }}</span>
        </v-col>
        <v-col class="d-flex justify-end pl-10">
          <v-switch
            v-model="externalLinkBtn"
            :hide-details="true"
            class="mt-0 pt-0"
          >
          </v-switch>
        </v-col>
      </v-row>
    </v-col>

    <template v-if="externalLinkBtn">
      <v-col cols="12" class="mb-6">
        <v-row no-gutters align="center" class="pa-2">
          <v-col class="d-flex flex-column" style="max-width: 200px">
            <span class="body-regular-small title-text-color">{{
              $t('message.playlist.settings.tabs.advanced.buttonText.title')
            }}</span>
          </v-col>
          <v-col class="d-flex justify-end pl-10">
            <v-input
              counter="20"
              max="20"
              @keydown="($event) => limit($event)"
              v-model="playlistData.external_button.text"
              :placeholder="
                $t(
                  'message.playlist.settings.tabs.advanced.buttonText.placeholder'
                )
              "
            ></v-input>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mb-6">
        <v-row no-gutters align="center" class="pa-2">
          <v-col class="d-flex flex-column" style="max-width: 200px">
            <span class="body-regular-small title-text-color">{{
              $t('message.playlist.settings.tabs.advanced.buttonUrl.title')
            }}</span>
          </v-col>
          <v-col class="d-flex justify-end pl-10">
            <v-input
              v-model="playlistData.external_button.url"
              :placeholder="
                $t(
                  'message.playlist.settings.tabs.advanced.buttonUrl.placeholder'
                )
              "
              hide-details
            ></v-input>
          </v-col>
        </v-row>
      </v-col>
    </template>

    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col class="d-flex flex-column" style="max-width: 221px">
          <span class="body-regular-small title-text-color">{{
            $t('message.playlist.settings.tabs.advanced.logo.title')
          }}</span>
          <span class="body-regular-smaller desc-text-color">{{
            $t('message.playlist.settings.tabs.advanced.logo.desc')
          }}</span>
        </v-col>
        <v-col class="d-flex justify-end pl-5">
          <base-upload-file-input
            v-model="imgFile"
            @update="updateImgPreview"
          />
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="mb-6">
      <v-row no-gutters align="center" class="pa-2">
        <v-col cols="12">
          <span class="body-regular-small title-text-color">{{
            $t('message.playlist.settings.tabs.advanced.preview.title')
          }}</span>
        </v-col>
        <v-col class="mt-2">
          <div class="preview-card">
            <img height="32" widht="135" :src="imagePreview" />
            <span class="pl-3 text-truncate">
              {{ playlist.name }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-col>

    <div class="save-action-divider"></div>

    <v-col cols="12" class="my-6">
      <div class="d-flex justify-end px-6">
        <base-btn type="tertiary" @click="handleGoBack">
          {{ $t('message.actions.cancel') }}
        </base-btn>
        <base-btn
          :disabled="!hasChanges || loadings.saveChanges"
          :loading="loadings.saveChanges"
          @click="handleSaveChanges"
          class="ml-2"
        >
          {{ $t('message.actions.save') }}
        </base-btn>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import BaseUploadFileInput from '@/components/BaseComponents/BaseUploadFileInput.vue'
import playlistApi from '@/services/playlistApi'
import imagesApi from '@/services/imagesApi'

export default {
  components: { BaseUploadFileInput },
  data() {
    return {
      imgFile: null,
      playlistData: {
        hide_views: false,
        creator_name: '',
        external_button: {},
      },
      initPlaylistData: {},
      externalLinkBtn: false,
      loadings: {
        saveChanges: false,
      },
      imagePreview: require('@/assets/logoWhite.svg'),
    }
  },
  watch: {
    externalLinkBtn(val) {
      if (val && !Object.keys(this.playlistData.external_button).length) {
        this.playlistData.external_button = {
          text: '',
          url: '',
          size: '16',
        }
      } else if (!val) {
        this.playlistData.external_button = {}
      }
    },
  },
  computed: {
    ...mapState({
      playlist: (state) => state.playlist.playlist,
    }),
    hasChanges() {
      return (
        this.imgFile || !_.isEqual(this.playlistData, this.initPlaylistData)
      )
    },
  },
  mounted() {
    this.handleResetData()
    if (this.playlist.image_id) {
      setTimeout(() => {
        document.querySelector(
          '.upload-file-input .v-text-field__slot input'
        ).value = `${this.playlist.image_id}.png`
      }, 1000)

      this.imagePreview = this.playlist.image_url
    }
  },
  methods: {
    ...mapMutations('playlist', ['UPDATE_PLAYLIST']),
    handleSelectImg() {
      this.$refs.uploadFile.$el.click()
    },
    limit(e) {
      if (
        this.playlistData.external_button.text.length > 19 &&
        e.key !== 'Backspace' &&
        !(e.key === 'a' && (e.metaKey || e.ctrlKey))
      ) {
        e.preventDefault()
      }
    },
    updateImgPreview(url) {
      this.imagePreview = url
    },
    handleGoBack() {
      this.$router.push({ name: 'Playlists' })
    },
    async uploadImgFile() {
      const data = new FormData()
      data.append('file', this.imgFile)
      var reader = new FileReader()
      reader.readAsDataURL(this.imgFile)
      return new Promise((resolve, reject) => {
        reader.onload = async () => {
          const options = [
            {
              filename: this.imgFile.name,
              type: 'template',
            },
          ]
          const data = await fetch(reader.result)
          const blobData = await data.blob()

          this.loading = true
          try {
            const data = await imagesApi.handleUploadImage(blobData, options)
            resolve(data)
          } catch (err) {
            reject(err)
          }
        }
      })
    },
    async tryDeleteOldImg() {
      try {
        await imagesApi.deleteImage(this.playlist.image_id)
      } catch (error) {
        console.error('Error deleting old image: ', error)
      }
    },
    async handleSaveChanges() {
      this.loadings.saveChanges = true
      try {
        if (this.imagePreview !== this.playlist.image_url) {
          if (this.playlist.image_url) {
            await this.tryDeleteOldImg()
          }
          const { cdn_base, storage_path, id } = await this.uploadImgFile()
          this.playlistData.image_url = `${cdn_base}/${storage_path}`
          this.playlistData.image_id = id
        }
        const { data } = await playlistApi.updatePlaylist(
          this.playlistData,
          this.playlist.id
        )
        if (data) {
          this.UPDATE_PLAYLIST(data)
        }
        this.handleResetData()
        this.showSuccessSnackbarAlert()
      } catch (error) {
        console.error('Error saving changes: ', error)
        this.showErrorSnackbarAlert(
          error?.response?.data?.errMsg ?? error?.response?.status
        )
      }
      this.loadings.saveChanges = false
    },
    showSuccessSnackbarAlert() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: this.$t('message.pages.video.changesSaved'),
        type: 'success',
      })
    },
    showErrorSnackbarAlert(errMsg = '') {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: `${this.$t('message.error')}: ${errMsg}`,
        type: 'error',
      })
    },
    handleResetData() {
      this.playlistData.hide_views = this.playlist.hide_views
      this.playlistData.creator_name = this.playlist.creator_name
      if (Object.keys(this.playlist.external_button).length) {
        this.externalLinkBtn = true
        this.playlistData.external_button = this.playlist.external_button
      }
      this.initPlaylistData = _.cloneDeep(this.playlistData)
    },
  },
}
</script>

<style lang="scss" scoped>
.preview-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  background-color: black;
  color: white;
  padding: 32px 24px;
  border-radius: 8px;
}
</style>
